import {SearchActionTypes} from '../actions/search.actions';
import {Map} from 'immutable';
import dieselReducer from '../../decorators/DieselReducer';
import {CatalogOffer} from 'epic-graphql-types';
import {Maybe} from '../../commonTypes';

export const initState = () =>
    Map({
        text: '',
        autocompleteResultString: '',
        autocompleteResults: {},
        searchFetching: false
    });

export interface AutocompleteResult {
    title: string;
    path: 'collection' | 'product';
    id: string;
    urlSlug: string;
    url: Maybe<string>;
}

export const parseOffer = (offer: CatalogOffer): Maybe<AutocompleteResult> => {
    const category = offer && offer.categories && offer.categories[0];

    if (category) {
        return {
            id: offer.id || '',
            title: offer.title || '',
            path: category.path === 'collections' ? 'collection' : 'product',
            urlSlug: offer.productSlug || '',
            url: offer.url || null
        };
    } else {
        console.error(`offer missing category: ${offer.id}`);
        return null;
    }
};

export const getAutocompleteResults = (state: any): AutocompleteResult[] => {
    const query = state.get('autocompleteResultString');
    return state.get('autocompleteResults')[query];
};

export const searchReducer = (state = initState(), {type, payload}) => {
    switch (type) {
        case SearchActionTypes.SET_SEARCH_TEXT: {
            if (payload.query === '') {
                return initState();
            }
            return state.set('text', payload.query);
        }
        case SearchActionTypes.SEARCH: {
            return state.set('searchFetching', true);
        }
        case SearchActionTypes.SEARCH_SUCCESS: {
            return state.set('searchFetching', false);
        }
        case SearchActionTypes.SEARCH_FAILURE: {
            return state.set('searchFetching', false);
        }
        case SearchActionTypes.FETCH_SEARCH_AUTOCOMPLETE_SUCCESS: {
            return state
                .set('autocompleteResultString', payload.query)
                .set('autocompleteResults', {[payload.query]: payload.offers.map(parseOffer)});
        }
        default:
            return state;
    }
};

dieselReducer('search', searchReducer);
